
import { Arr } from '@deqo/foundation';
import { Sounds } from '../../../@resources/sounds';
import { ObjectUpdate } from '../../../concepts/objects';
import { CreatePhysicalToolBehavior2 } from '../../canvas/tooling/CreatePhysicalToolBehavior2';
import { defineToolWithCommonBehaviors } from '../../canvas/tooling/Definitions';
import { Buzzer } from './Buzzer';

class CreateBuzzerToolBehavior extends CreatePhysicalToolBehavior2(Buzzer, 'plop') {

    protected createSubject(u: ObjectUpdate) {
        const subject = super.createSubject(u);
        subject.width = 140;
        subject.height = 140;
        subject.sound = Arr.random([
            Sounds.Buzzer1,
            Sounds.Buzzer2,
            Sounds.Buzzer3,
            Sounds.Buzzer4,
            Sounds.Buzzer5,
        ]);

        return subject;
    }
}

export const buzzerTool = defineToolWithCommonBehaviors({
    id: 'buzzerTool',
    label: 'Buzzer',
    category: 'objects',
    behaviors: [
        CreateBuzzerToolBehavior,
    ]
});
